'use strict';
const GuidelineCtrl = function ($scope, $rootScope, $timeout) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;

    this.$scope.radio = {
        example: false,
        example2: false,
        example3: false,
    };
};


app.controller('GuidelineCtrl', [
    '$scope', '$rootScope', '$timeout',
    GuidelineCtrl
]);
